<div class="sts-banner-header full-height ">

  <div class="sts full-height container-fluid">
    <div class="full-height row">

      <div class="full-height col-12">
        <div class="dtb full-height">
          <div class="dtr full-height">
            <div class="logo dtd full-height" [innerHTML]="config.logo"></div>
          </div>
        </div>
      </div>

      <div class="full-height right-header col-12">
        <div class="dtb full-height">
          <div class="dtr full-height">
            <div class="dtd full-height">
              <span class="inline-action" *ngIf="config.languages && config.languages.length > 1">
                <a href="#"
                  *ngFor="let language of config.languages; let i = index"
                  [ngClass]="{'active-language': language.locale.toLowerCase() == tenantInfo.currentLocale.toLocaleLowerCase()}"
                  class="language-toggle"
                  (click)="setLocale(language.locale)">{{getLocale(language.locale)}}
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
